import { render, staticRenderFns } from "./Dialogs_AddNewTeam.vue?vue&type=template&id=09664be4&scoped=true&"
import script from "./Dialogs_AddNewTeam.vue?vue&type=script&lang=js&"
export * from "./Dialogs_AddNewTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09664be4",
  null
  
)

export default component.exports